@if (warningType !== undefined) {
  <app-blade-header [bladeIndex]="bladeIndex">
    <ng-container title>
      <div class="warning-icon">
        <app-warning-icon [messageType]="messageType"></app-warning-icon>
      </div>
      @if (title$ | async; as title) {
        <div>
          {{ title }}
        </div>
      }
      @if (items?.length > 0) {
        <span class="left-margin tag mini-tag">
          {{ items?.length }}
        </span>
      }
    </ng-container>
    <ng-container actions>
      @if (shouldShowDeviationFilter && deviationsFilter) {
        <div
          class="filter clickable"
          (click)="filterExpanded = !filterExpanded"
          >
          <span class="info">
            > {{ deviationsFilter.hours | number: '2.0' }}:{{ deviationsFilter.minutes | number: '2.0' }}:{{
            deviationsFilter.seconds | number: '2.0'
            }}</span
            >
            <span>
              <mat-icon class="toggle">{{
                filterExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              }}</mat-icon>
            </span>
          </div>
        }
      </ng-container>
    </app-blade-header>
    @if (shouldShowDeviationFilter && deviationsFilter && filterExpanded) {
      <div class="filter">
        <ng-container>
          <app-deviation-filter
            [warningType]="warningType"
            [deviationsFilter]="deviationsFilter"
            (deviationFilterChanged)="onDeviationFilterChanged($event)"
            >
          </app-deviation-filter>
        </ng-container>
      </div>
    }
    <app-tabs
      [tabs]="componentState?.tabs"
      [tabsInfo]="tabsInfo"
      [selectedTab]="componentState?.selectedTab"
      (changed)="changeTab($event)"
    ></app-tabs>
    @if (items?.length > 0) {
      <app-compact-list
        [items]="items"
        [columns]="columns"
        (itemSelected)="vehicleItemSelected($event)"
        (columnsUpdated)="vehicleColumnsUpdated($event)"
        >
      </app-compact-list>
    } @else {
      @if (shouldShowDeviationFilter) {
        <app-feedback-text type="empty">
          {{ 'No warnings is matching the filter' | translate }}
        </app-feedback-text>
      } @else {
        <app-feedback-text type="empty">
          {{ 'Could not find any warnings' | translate }}
        </app-feedback-text>
      }
    }
  }
